export const MAX_RECONNECT_ATTEMPTS = 2;

const SESSION_ERROR_PATTERNS = [
  'session not initialized',
  'InvalidAgentSession',
  'session expired',
  'not authenticated',
] as const;

export function isCxoneSessionError(error: Error | string): boolean {
  const errorMessage = error instanceof Error ? error.message : error;
  return SESSION_ERROR_PATTERNS.some((pattern) => errorMessage.includes(pattern));
}
